import { active } from "./const.js";
const navItems = document.querySelectorAll('.js-globalNavItem');

navItems.forEach(item => {
  let hoverTimeout;

  const localNav = item.querySelector('.js-globalLocalNav');

  item.addEventListener('mouseenter', () => {
    hoverTimeout = setTimeout(() => {
      localNav.classList.add(active);
    }, 100);
  });

  item.addEventListener('mouseleave', () => {
    clearTimeout(hoverTimeout);
    localNav.classList.remove(active);
  });
});
